import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Composable that provides a reactive current time that updates every minute
 * @returns Reactive ref containing the current time
 */
export function useCurrentTime(options: { durationInMinutes: number } = { durationInMinutes: 1 }) {
  const currentTime = ref(new Date())
  let timer: NodeJS.Timeout | null = null

  const startTimer = () => {
    // Update time immediately
    currentTime.value = new Date()

    // Calculate milliseconds until the next full minute
    const now = new Date()
    const secondsUntilNextMinute = 60 - now.getSeconds()
    const millisecondsUntilNextMinute = secondsUntilNextMinute * 1000 - now.getMilliseconds()

    // Set up timer to start at the next full minute, then repeat every minute
    timer = setTimeout(() => {
      // Update time at the start of the next minute
      currentTime.value = new Date()

      // Then set up the regular interval for every minute after that
      timer = setInterval(() => {
        currentTime.value = new Date()
      }, options.durationInMinutes * 60000) // 60000ms = 1 minute
    }, millisecondsUntilNextMinute)
  }

  const stopTimer = () => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  onMounted(() => {
    startTimer()
  })

  onUnmounted(() => {
    stopTimer()
  })

  return {
    currentTime,
  }
}
